import { effect } from '@preact/signals-react'
import { notification } from 'antd'
import { OfflineState } from '.'
import { FaWifi } from 'react-icons/fa6'
import { MdOutlineWifiOff } from 'react-icons/md'
import { initSynchronizing } from './utils'
import offlineDB from '@/indexeddb'
import { BsDatabaseFillX } from 'react-icons/bs'

effect(initSynchronizing)

export const offlineStateActions = {
  cleanDB: () => {
    offlineDB.clearAllDB().then(() => {
      OfflineState.storeApplications.value = []
      notification.info({
        message: 'Data local eliminada exitosamente',
        icon: <BsDatabaseFillX />,
        placement: 'top',
      })
    })
  },
  deleteApplication: async (applicationId: string) => {
    await offlineDB.deleteFromStore({
      storeName: offlineDB.stores.APPLICATIONS_STORE,
      key: applicationId,
    })
    if (!OfflineState.isOnline.peek()) {
      await offlineDB.saveMultipleToStore(
        offlineDB.stores.DELETED_APPLIES_STORE,
        [{ id: applicationId }]
      )
    }
  },
  setConnectionOffline: (manual?: boolean) => {
    OfflineState.isOnline.value = false
    OfflineState.isSynchronizing.value = false
    OfflineState.syncAppsIds.value = []

    if (!manual) {
      notification.info({
        description:
          'Has perdido la conexión a internet, el aplicativo estará en modo Offline mientras recuperas la conexión',
        message: 'Conexión perdida',
        icon: <MdOutlineWifiOff />,
        placement: 'top',
      })
    }
  },
  setConnectionOnline: (manual?: boolean) => {
    OfflineState.isOnline.value = true

    if (!manual) {
      notification.info({
        description:
          'La conexión a internet se ha reestablecido correctamente. Si tienes información pendiente de sincronización, el proceso se iniciará automáticamente y te informaremos cuando este haya finalizado.',
        message: 'Conexión establecida',
        icon: <FaWifi />,
        placement: 'top',
      })
    }
  },
  setCurrentSyncIds: (appsSyncIds: string[]) => {
    OfflineState.syncAppsIds.value = appsSyncIds
  },
  setOfflineStoreApplications: (ids: string[]) => {
    const uniqueApplicationsStoreIds = new Set([
      ...OfflineState.storeApplications.peek(),
      ...ids,
    ])
    OfflineState.storeApplications.value = [...uniqueApplicationsStoreIds]
  },
  switchConnection: () => {
    if (!OfflineState.existNetworkConnection.peek()) {
      return
    }

    const isCurrentlyOnline = OfflineState.isOnline.peek()

    if (isCurrentlyOnline) {
      offlineStateActions.setConnectionOffline(true)
    }

    if (!isCurrentlyOnline) {
      offlineStateActions.setConnectionOnline(true)
    }
  },
  setNetworkConnection: () => {
    const hasConnectionNow = navigator.onLine

    if (hasConnectionNow) {
      offlineStateActions.setConnectionOnline()
    }

    if (!hasConnectionNow) {
      offlineStateActions.setConnectionOffline()
    }

    OfflineState.existNetworkConnection.value = hasConnectionNow
  },
  deleteApplicationsSynched: async (applicationIds: string[]) => {
    await offlineDB.deleteFromStore({
      storeName: offlineDB.stores.APPLICATIONS_STORE,
      keys: applicationIds,
    })
  },
}
